module.exports = __webpack_public_path__ + "static/media/Raleway-Regular.20d41940.ttf";